export const CREATE_OTHER_LEAVE = "CREATE_OTHER_LEAVE";
export const FETCH_OTHER_LEAVES = "FETCH_OTHER_LEAVES";
export const FETCH_OTHER_LEAVE = "FETCH_OTHER_LEAVE";
export const EDIT_OTHER_LEAVE = "EDIT_OTHER_LEAVE";
export const DELETE_OTHER_LEAVE = "DELETE_OTHER_LEAVE";
